var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInhibitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1539 1539",
    style: {
      enableBackground: "new 0 0 1539 1539"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2A2A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Inhibitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M769.5,0C344.5,0,0,344.5,0,769.5S344.5,1539,769.5,1539S1539,1194.5,1539,769.5S1194.5,0,769.5,0z  M769.5,1287.5c-286.1,0-518-231.9-518-518s231.9-518,518-518s518,231.9,518,518S1055.6,1287.5,769.5,1287.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.1,
    y: 503.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -318.7381 769.4981)",
    className: "st0",
    width: 532.8,
    height: 532.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhibitor);
export default __webpack_public_path__ + "static/media/inhibitor.9b6a533d94f7b6f034f8eb5695480b0c.svg";
export { ForwardRef as ReactComponent };